<template>
  <v-layout align-center wrap>
    <v-flex xs2>
      <h3 class="subheading grey--text text--darken-2">代理店名（必須）</h3>
    </v-flex>
    <v-flex xs10>
      <SearchAndSelect
        v-if="!isEdit"
        :loading="loading"
        :searched-list="filteredAgencyList"
        :selected-item="selectedItem"
        @search="getList"
        @change="selectItem"
        @clearList="clearList"
        show-list-on-init
        modal-title="代理店検索"
        button-text="代理店を検索"
      >
        <template #item="{ item }">
          <AppAgencyName :agency="item" :with-system-owner="isSuperAdmin" />
        </template>
        <template #selection="{ item }">
          <AppAgencyName :agency="item" :with-system-owner="isSuperAdmin" />
        </template>
        <template #append>
          <v-btn @click="navigateToAddAgency" small flat color="primary">
            <v-icon>open_in_new</v-icon>代理店を追加
          </v-btn>
        </template>
      </SearchAndSelect>
      <div v-else>
        <slot name="fixed" />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import SearchAndSelect from '@/components/Shared/CrudUI/SearchAndSelect'

export default {
  name: 'EditModalSearchAgency',
  components: { SearchAndSelect },
  props: {
    value: {
      // agencyId
      type: Number,
      default: 0,
    },
    agencyList: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isSuperAdmin: Boolean,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    filteredAgencyList() {
      return this.agencyList.filter(a => a.status === 'active')
    },
    selectedItem() {
      return this.value
        ? this.filteredAgencyList.find(a => a.id === this.value)
        : null
    },
  },
  methods: {
    async getList(keyword) {
      if (keyword === '') {
        return
      } else {
        this.loading = true
        try {
          await this.$store.dispatch('admin/advertiser/SEARCH_AGENCY', {
            keyword: keyword,
            minPermissionLevel: 'admin',
          })
        } catch (e) {
          this.loading = false
          const error = new Error('代理店の取得に失敗しました。')
          throw error
        }
        this.loading = false
      }
    },
    selectItem(item) {
      this.selectedItemName = item.name
      this.$emit('input', item.id)
    },
    async navigateToAddAgency() {
      const confirmed = await this.$confirm(
        '現在の画面を閉じて代理店追加画面へ移動します。よろしいですか？',
      )
      confirmed && this.$router.push('/admin/agencies#add').catch(() => {})
    },
    clearList() {
      this.$store.dispatch('admin/advertiser/CLEAR_AGENCY_LIST')
      return
    },
  },
}
</script>
